import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { Grid, Collapse } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { SideBarContext } from '../../layouts/SideBarLayout/SideBarLayout';
import {
  StyledWrapChildren,
  StyledWrapper,
  StyledExpandMoreIcon,
  StyledKeyboardArrowRightIcon,
  StyledTitle,
} from './SideBarItem.styled';

const SideBarItem = props => {
  const [isOpen, setIsOpen] = useState(false);
  const { title, children, path, isActive } = props;

  const { handleClose } = useContext(SideBarContext);

  const history = useHistory();

  const handleClickItem = () => {
    if (children) {
      setIsOpen(!isOpen);
    }
    if (!children) {
      history.push(path);
    }
  }

  useEffect(() => {
    if (isActive) {
      setIsOpen(true);
    }
  },[isActive ,setIsOpen]);

  return (
    <div>
      <StyledWrapper isActive={isActive} onClick={children ? () => {} : handleClose}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          onClick={handleClickItem}
        >
          <Grid item>
            <StyledTitle isActive={isActive}>
              {title}
            </StyledTitle>
          </Grid>
          <Grid item>
          {
            children && (
              isOpen ? (
                  <StyledExpandMoreIcon fontSize='default'/>
                ) : (
                <StyledKeyboardArrowRightIcon fontSize='default'/>
              )
            )
          }
          </Grid>
        </Grid>
      </StyledWrapper>
      <StyledWrapChildren>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      </StyledWrapChildren>
    </div>
  )
}

SideBarItem.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  isActive: PropTypes.bool,
}

SideBarItem.defaultProps = {
  title: 'Test',
  path: '/',
  isActive: false,
}

export default SideBarItem
